// extracted by mini-css-extract-plugin
module.exports = {"container":"loading_container_container__3kYN5","overlayText":"loading_container_overlayText__2uQta"};